import { render, staticRenderFns } from "./HorizontalStatistic.vue?vue&type=template&id=4562a450"
import script from "./HorizontalStatistic.vue?vue&type=script&lang=ts"
export * from "./HorizontalStatistic.vue?vue&type=script&lang=ts"
import style0 from "./HorizontalStatistic.vue?vue&type=style&index=0&id=4562a450&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports